import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import {  HttpClient,HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import { Feed } from './model/feed';
import * as xml2js from "xml2js";

@Injectable()
export class FeedService {

  private rssToJsonServiceBaseUrl: string = 'https://api.rss2json.com/v1/api.json?rss_url=';

  constructor(
      private http: Http, private httpClient:HttpClient
  ) { }

/*   getFeedContent(url: string): Observable<Feed> {
    return this.http.get(this.rssToJsonServiceBaseUrl + url)
        .map(this.extractFeeds)
        .catch(this.handleError);
  } */
//   getFeedContent(url: string): Observable<Feed> {
//    /*  var params = new HttpParams()
//   .set("count", "5")
//   .set("order_by", "title").set("order_dir", "desc").set("api_key", "kaarqtfmpqaihkrr90ahonfokbwluqglkio3m1fv"); */
//   var params = new HttpParams()
//  .set("api_key", "kaarqtfmpqaihkrr90ahonfokbwluqglkio3m1fv");
  
//     return this.httpClient.get(this.rssToJsonServiceBaseUrl + url,{params})
//         .map(this.extractFeeds)
//         .catch(this.handleError);
//   }
  
//   private extractFeeds(res: Response): any {
//    // console.log("feed",res);
//    // this.callFeed.status=res.status.toString(); 
//    // this.callFeed.feed=
//     let feed = res;
    
//     return feed || { };
//   }

  getFeedContent(): Observable<Feed> {
    return this.httpClient.get('https://www.apa.org/news/psycport/psycport-rss.xml')
          .map(this.extractFeeds)
          .catch(this.handleError)
  }

  private extractFeeds(res): any {
    let feed = {};
    let parseString = xml2js.parseString;
    parseString(res, (err, result: Feed) => {
      feed = result;
    });    
    
    return feed;
  }

  private handleError (error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/feed.service.ts